import React from 'react';

/**
 * Component for displaying general system settings
 * Shows core system information (read-only)
 */
const GeneralSettingsSection = ({ 
  settings = {
    systemName: 'App Analysis System',
    systemVersion: '1.0.0',
    developerMode: false
  },
  onUpdateSettings
}) => {
  return (
    <div className="bg-gray-900 rounded-xl shadow-xl p-4 sm:p-6 mb-6 border border-gray-800 w-full">
      <div className="flex items-center space-x-4 mb-4">
        <h2 className="text-lg sm:text-xl font-semibold text-blue-400">System Information</h2>
        <div className="bg-blue-500/10 px-3 py-1 rounded-full">
          <span className="text-xs text-blue-400">Read Only</span>
        </div>
      </div>
      
      <div className="space-y-4">
        <div className="bg-gray-800/50 p-4 rounded-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <label className="text-sm font-medium text-gray-300 min-w-[120px]">
                System Name:
              </label>
              <div className="text-white text-sm">
                {settings.systemName}
              </div>
            </div>
            <div className="flex items-center">
              <span className="text-xs text-blue-400 mr-2">Active</span>
              <div className="w-2 h-2 rounded-full bg-blue-400"></div>
            </div>
          </div>
        </div>
        
        <div className="bg-gray-800/50 p-4 rounded-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <label className="text-sm font-medium text-gray-300 min-w-[120px]">
                System Version:
              </label>
              <div className="text-white text-sm">
                {settings.systemVersion}
              </div>
            </div>
            <div className="flex items-center">
              <span className="text-xs text-emerald-400 mr-2">Latest</span>
              <div className="w-2 h-2 rounded-full bg-emerald-400"></div>
            </div>
          </div>
        </div>

        <div className="bg-gray-800/50 p-4 rounded-lg">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <label className="text-sm font-medium text-gray-300 min-w-[120px]">
                Developer Mode:
              </label>
              <div className="text-white text-sm flex items-center">
                <button 
                  onClick={() => onUpdateSettings('developerMode', !settings.developerMode)}
                  className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${settings.developerMode ? 'bg-blue-600' : 'bg-gray-700'}`}
                >
                  <span
                    className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${settings.developerMode ? 'translate-x-6' : 'translate-x-1'}`}
                  />
                </button>
                <span className="ml-2">{settings.developerMode ? 'Enabled' : 'Disabled'}</span>
              </div>
            </div>
          </div>
          <div className="mt-2 text-xs text-gray-400">
            Enable developer mode to show development buttons on pricing page and other advanced features.
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralSettingsSection; 